import { type SizingProps } from '@material-ui/system'

import {
  type CreditCardVendorEnum,
  CreditCardVendors,
} from '@webapp/core/entities/external/CreditCardVendor'
import { useFormatCreditCardTypeToLabel } from '@webapp/core/hooks/useFormatCreditCardTypeToLabel'
import AMEX from './assets/amex.jpg'
import DINERSCLUB from './assets/diners-club.jpg'
import DISCOVER from './assets/discover.jpg'
import JCB from './assets/jcb.jpg'
import MASTERCARD from './assets/mastercard.jpg'
import OTHERCC from './assets/other-credit-card.png'
import VISA from './assets/visa.jpg'
import { CreditCardIconStyled } from './styles/CreditCardIconStyled'

const creditCardImage: Record<CreditCardVendorEnum, string> = {
  [CreditCardVendors.VISA]: VISA,
  [CreditCardVendors.MASTERCARD]: MASTERCARD,
  [CreditCardVendors.AMERICAN_EXPRESS]: AMEX,
  [CreditCardVendors.DISCOVER]: DISCOVER,
  [CreditCardVendors.JCB]: JCB,
  [CreditCardVendors.DINERS_CLUB]: DINERSCLUB,
  [CreditCardVendors.OTHER]: OTHERCC,
  [CreditCardVendors.PROCURIFY]: OTHERCC,
} as const

export interface ICreditCardIconProps extends SizingProps {
  type?: CreditCardVendorEnum
}

export const CreditCardIcon = ({
  type = CreditCardVendors.OTHER,
  ...otherProps
}: ICreditCardIconProps) => {
  const formatTypeToLabel = useFormatCreditCardTypeToLabel()

  return (
    <CreditCardIconStyled {...otherProps}>
      <img
        src={creditCardImage[type] || creditCardImage[CreditCardVendors.OTHER]}
        aria-label={formatTypeToLabel(type)}
      />
    </CreditCardIconStyled>
  )
}

CreditCardIcon.displayName = 'CreditCardIcon'
